<script>
export default {
  name: 'RedemptionList',
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      students: {},
      guardians: {},
      redemptions: [],
    }
  },
  methods: {
    async getRedemptions() {
      this.redemptions = (await this.$firestore.collection(this.options.type)
        .doc(this.options.id)
        .collection('redemptions')
        .get())
        .docs.map(doc => doc.data())
      if (this.redemptions) this.getDetails()
    },
    async getDetails () {
      this.redemptions.forEach(async record => {
        this.guardians[record.guardian] = (await this.$firestore.collection('users').doc(record.guardian).get()).data()
        record.students.forEach(async studentId => {
          this.students[studentId] = (await this.$firestore.collection('users').doc(studentId).get()).data()
          this.$forceUpdate()
        })
      })
    },
  },
  async mounted () {
    await this.getRedemptions()
  },
}
</script>

<template lang="pug">
  #redemption-main.modal-main
    .redemption-container.modal-container
      .title Redemptions
      .section(v-if='Object.keys(redemptions).length === 0') No redemptions
      .section(
        v-else
        v-for='record in redemptions'
      ) 
        .title Redeemed {{new Date(record.date).toLocaleDateString()}}
        .content
          .label Guardian
          .value {{guardians[record.guardian] ? guardians[record.guardian].name : '...'}}
          .label Student{{record.students.length > 1 ? 's' : ''}}
          .value 
            .sub-value(
              v-for='studentId in record.students'
            ) {{students[studentId] ? students[studentId].name : '...'}}
          .label Class{{record.classes.length > 1 ? 'es' : ''}}
          .value {{record.classes.join(', ')}}

      .action
        .button.minor(
          @click='$modals.hide(`redemption-list`)'
        ) Close
</template>

<style lang="sass" scoped>
  .modal-main
    .modal-container
      .section
        .title
          font-weight: 600
          font-size: 1.1em
        .content
          display: grid
          grid-template-columns: auto 1fr
          grid-column-gap: 1rem
          grid-row-gap: 0.5rem
          margin-bottom: 2rem
</style>